import { Button } from "@/components/core/buttons/button";
import { Form, FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage, FormPrepend } from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { useUserEmailMutation } from "@/features/dashboard/api/queries/user-queries";
import { type UserEmail, userEmailSchema } from "@/features/dashboard/types/user";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

export default function EditEmailModal({
	user,
}: {
	user?: any;
}) {
	const { closeModal } = useModalControl();
	const form = useForm<UserEmail>({
		resolver: zodResolver(userEmailSchema),
		defaultValues: {
			email: user.user?.email || "",
			id: user?.user?.id,
		},
	});

	const editEmailMutation = useUserEmailMutation();

	const onSubmit = async (data: UserEmail) => {
		await editEmailMutation.mutateAsync(data);
		closeModal();
	};

	console.log(form.formState.errors);

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(onSubmit)}>
				<div className="flex flex-col w-full gap-4">
					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-col items-center justify-between w-full py-3 px-4 gap-3">
							<div className="grid grid-cols-12 w-full py-1 gap-x-4 gap-y-3">
								<div className="col-span-12 flex">
									<FormField
										control={form.control}
										name="email"
										render={({ field }) => (
											<FormItem>
												<FormLabel required>Email Address</FormLabel>
												<FormGroup iconPosition="left">
													<Input autoComplete="off" {...field} />
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="flex flex-row justify-between w-full pt-4">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button className="" loading={form.formState.isSubmitting}>
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
